import * as React from 'react';
import "./Toast.css";
import RightTick from "../../../assets/svg/right-tick.svg";
import { url } from 'inspector';
import { CircleXCloseMark } from '../../../assets/Icons';

export interface IAppProps {
    message: string;
    type: 'success' | 'failure';
    onClose: () => void;
}

const getStatusCircle = (type: string | undefined) => {
    switch (type) {
        case "success":
            return "#004004"
        case "failure":
            return "#A90B0B"
        default:
            break;
    }
}

const Toast: React.FC<IAppProps> = ({ message, type, onClose }) => {
    React.useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000);
        return () => clearTimeout(timer);
    }, [onClose]);
    return (
        <div className={`toast-container ${type} flex items-center justify-between gap-2`}>
            <div className=" flex items-center gap-3">
                <div className={`rounded-full w-6 h-6 flex flex-col items-center justify-center`} style={{
                    backgroundColor: `${getStatusCircle(type)}`
                }} >
                    {type === "success" ?

                        <img src={RightTick} alt="" width={12} height={12} />
                        :
                        <CircleXCloseMark />
                    }
                </div>
                <div className='flex flex-col items-start gap-2'>
                    <p className='toast-message'>
                        {type === "success" ? "Successfullly Completed" : "Submission Unsuccessful"}
                    </p>
                    <p className='text-xs text-[#626262]'>
                        {message}
                    </p>
                </div>
            </div>
            <div onClick={onClose} className='cursor-pointer'>
                <CircleXCloseMark fillColor='#000' />
            </div>
        </div>

    )
}

export default Toast;
